import { useEffect, useState } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Modal } from "@mui/material";
import Slideshow from "../components/Slideshow";

import DemoForm from "../components/forms/Form";
import FormMini from "../components/forms/FormMini";
import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";
import ExitModal from "../components/ExitModal";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "900px",
  height: "calc((95vw * .5625) + 40)",
  maxWidth: "95vw",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);
  const [open, setOpen] = useState(false);
  const handleOpen = (e) => {
    setOpen(e.target.id);
  };
  const handleClose = () => setOpen(false);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>IDX Websites - Elm Street</title>
        <meta
          name="description"
          content="Whether you are seeking a quick turn-key website for your budding real estate business, an affordable, semi-custom website with interactive IDX, or a full-blown custom design, Elm Street's got you covered."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/idx_websites" />
        <meta property="og:title" content="IDX Websites - Elm Street" />
        <meta
          property="og:description"
          content="Whether you are seeking a quick turn-key website for your budding real estate business, an affordable, semi-custom website with interactive IDX, or a full-blown custom design, Elm Street's got you covered."
        />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />



      <ExitModal>
      <div style={{padding:"25px"}}>
                <div style={{textAlign:"center", paddingBottom:"10px"}}> <Typography variant="h4" component="h2" style={{ color: "#333666", textAlign: "center", paddingBottom:"10px" }}>Take The 30-Day <br /><span style={{color:"#f69c26"}}>Marketing Challenge!</span></Typography>
                </div>
                <div style={{textAlign:"center", paddingBottom:"10px"}}>A free downloadable guide with Simple steps to elevate your marketing in less than 1-month.
                </div>
                
                <FormMini buttonText="accept the challenge" successMsg={<div style={{textAlign:"center"}}><Button variant="contained" color="secondary" href="/assets/30daymarketingchallenge.pdf">Download the PDF</Button></div>}
              formName="es2_marketing_challenge" listId="148009" utmOverride="exit_intent" />
                
         </div>
         <div style={{textAlign:"center"}}>
         <Image
                    src="/mcgo.jpg"
                    width="590px"
                    height="242px"
                    alt="30 Day Marketing Challenge FREE Guide"
                   
                  />
                  </div>
     </ExitModal>






      <div
        style={{
          backgroundImage: "url('idxbg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
        alt="Elm Street IDX Websites"
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  height: "400px",
                }}
              >
                <div>
                  <Typography variant="h2" component="h1">
                    mobile friendly
                    <br />
                    <span style={{ color: mainTheme.palette.secondary.main }}>idx websites</span>
                  </Typography>
                  <p>“A website is a window through which your business says hello to the world.”</p>
                  <Button variant="contained" color="secondary" href="#form">
                    schedule demo
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <Container maxWidth="lg" style={{ paddingLeft: "20px", paddingRight: "20px" }}>
        <div
          style={{
            marginTop: "55px",
            marginBottom: "55px",
            textAlign: "center",
          }}
        >
          <Grid container spacing={8}>
            <Grid item md={12} sm={12}>
              Whether you are seeking a quick turn-key website for your budding real estate business, an affordable,
              semi-custom website with interactive IDX, or a full-blown custom design, Elm Street's got you covered.
            </Grid>
          </Grid>
        </div>
      </Container>

      <Modal
        open={open === "turnkey"}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Slideshow
            pages={[
              <div key="1">
                <Image
                  src="/lightbox/turnkeya.jpg"
                  width="900px"
                  height="506px"
                  style={{ maxWidth: "100%" }}
                  alt="Turn-key example 1"
                />
              </div>,
              <div key="2">
                <Image
                  src="/lightbox/turnkeyb.jpg"
                  width="900px"
                  height="506px"
                  style={{ maxWidth: "100%" }}
                  alt="Turn-key example 2"
                />
              </div>,
              <div key="3">
                <Image
                  src="/lightbox/turnkeyc.jpg"
                  width="900px"
                  height="506px"
                  style={{ maxWidth: "100%" }}
                  alt="Turn-key example 3"
                />
              </div>,
            ]}
          />
        </Box>
      </Modal>

      <Modal
        open={open === "semi"}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Slideshow
            pages={[
              <div key="1">
                <Image
                  src="/lightbox/semia.jpg"
                  width="900px"
                  height="506px"
                  style={{ maxWidth: "100%" }}
                  alt="Semi-custom example 1"
                />
              </div>,
              <div key="2">
                <Image
                  src="/lightbox/semib.jpg"
                  width="900px"
                  height="506px"
                  style={{ maxWidth: "100%" }}
                  alt="Semi-custom example 2"
                />
              </div>,
              <div key="3">
                <Image
                  src="/lightbox/semic.jpg"
                  width="900px"
                  height="506px"
                  style={{ maxWidth: "100%" }}
                  alt="Semi-custom example 3"
                />
              </div>,
            ]}
          />
        </Box>
      </Modal>

      <Modal
        open={open === "custom"}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Slideshow
            pages={[
              <div key="1">
                <Image
                  src="/lightbox/customa.jpg"
                  width="900px"
                  height="506px"
                  style={{ maxWidth: "100%" }}
                  alt="Custom example 1"
                />
              </div>,
              <div key="2">
                <Image
                  src="/lightbox/customb.jpg"
                  width="900px"
                  height="506px"
                  style={{ maxWidth: "100%" }}
                  alt="Custom example 2"
                />
              </div>,
              <div key="3">
                <Image
                  src="/lightbox/customc.jpg"
                  width="900px"
                  height="506px"
                  style={{ maxWidth: "100%" }}
                  alt="Custom example 3"
                />
              </div>,
            ]}
          />
        </Box>
      </Modal>

      <div>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingBottom: "3px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={5} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4">
                  <span style={{ color: "#f69c26" }}>
                    turn-key
                    <br />
                  </span>{" "}
                  websites
                </Typography>
                <br />
                <span>
                  Large Template Library
                  <br />
                  Mobile-Friendly
                  <br />
                  SEO-Friendly
                  <br />
                  Robust Blog with Automated Posts for
                  <br />
                  MLS Listings &amp; Lifestyle Content
                  <br />
                  Built-In Lead Capture
                  <br />
                  Fanatical Customer Service &amp; Technical Support
                  <div style={{ paddingTop: "20px" }}>
                    <Button variant="contained" color="secondary" onClick={handleOpen} id="turnkey">
                      view gallery
                    </Button>{" "}
                    <Button variant="contained" color="secondary" href="#form">
                      schedule demo
                    </Button>
                  </div>
                </span>
              </Grid>
              <Grid item md={7} sm={12} style={{ marginBottom: "-9px" }}>
                <div>
                  <Image
                    src="/idx1.png"
                    width="1000px"
                    height="602px"
                    alt="Elm Street IDX Websites - Turn-key Websites"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div
        style={{
          backgroundImage: "url('esbg3.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "25px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={5} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4" style={{ color: "#ffffff" }}>
                  <span style={{ color: "#f69c26" }}>
                    semi-custom
                    <br />
                  </span>{" "}
                  websites
                </Typography>
                <br />
                <span style={{ color: "#ffffff" }}>
                  Large Template Library
                  <br />
                  Mobile-Friendly
                  <br />
                  SEO-Friendly
                  <br />
                  Robust Blog with Automated Posts for
                  <br />
                  MLS Listings &amp; Lifestyle Content
                  <br />
                  Built-In Lead Capture
                  <br />
                  Fanatical Customer Service &amp; Technical Support
                  <div style={{ paddingTop: "20px" }}>
                    <Button variant="contained" color="secondary" onClick={handleOpen} id="semi">
                      view gallery
                    </Button>{" "}
                    <Button variant="contained" color="secondary" href="#form">
                      schedule demo
                    </Button>
                  </div>
                </span>
              </Grid>
              <Grid item md={7} sm={12} style={{ marginBottom: "-6px" }}>
                <div>
                  <Image
                    src="/idx2.png"
                    width="1000px"
                    height="602px"
                    alt="Elm Street IDX Websites - Semi-Custom Websites"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div style={{ backgroundColor: "#f7f7f7" }}>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "25px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={5} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4">
                  <span style={{ color: "#f69c26" }}>
                    custom
                    <br />
                  </span>{" "}
                  websites
                </Typography>
                <br />
                <span>
                  100% Flexible Design
                  <br />
                  Full-Service Design Team
                  <br />
                  Mobile-Friendly
                  <br />
                  SEO-Friendly
                  <br />
                  Fanatical Customer Service &amp; Technical Support
                  <div style={{ paddingTop: "20px" }}>
                    <Button variant="contained" color="secondary" onClick={handleOpen} id="custom">
                      view gallery
                    </Button>{" "}
                    <Button variant="contained" color="secondary" href="#form">
                      schedule consult
                    </Button>
                  </div>
                </span>
              </Grid>
              <Grid item md={7} sm={12} style={{ marginBottom: "-6px" }}>
                <div>
                  <Image
                    src="/idx3.png"
                    width="1000px"
                    height="602px"
                    alt="Elm Street IDX Websites - Custom Websites"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <Container maxWidth="lg" style={{ marginTop: "45px", marginBottom: "68px" }}>
        <div
          style={{
            paddingTop: "55px",
            paddingBottom: "55px",
            textAlign: "center",
          }}
        >
          <Typography variant="h5" component="h5">
            <span style={{ color: "#f69c26" }}>stand out</span> with these features
          </Typography>
        </div>

        <Grid container columnSpacing={16} style={{ textAlign: "center" }}>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image
                src="/mobile_icon.svg"
                width="100px"
                height="100px"
                alt="Elm Street IDX Websites - Mobile-Friendly Design"
              />
            </div>
            <strong>MOBILE-FRIENDLY DESIGN</strong>
            <br />
            Amazing user experience for people on-the-go.
          </Grid>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image
                src="/responsive_icon.svg"
                width="100px"
                height="100px"
                alt="Elm Street IDX Websites - Fully-Responsive Design"
              />
            </div>
            <strong>FULLY-RESPONSIVE DESIGN</strong>
            <br />
            Works on every device, any
            <br />
            screen size.
          </Grid>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image src="/search_icon.svg" width="100px" height="100px" alt="Elm Street IDX Websites - IDX Search" />
            </div>
            <strong>IDX SEARCH</strong>
            <br />
            Features Quick, advanced search, interactive maps, customizable fields.
          </Grid>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image
                src="/lead_icon.svg"
                width="100px"
                height="100px"
                alt="Elm Street IDX Websites - Built-In Lead Capture"
              />
            </div>
            <strong>
              BUILT-IN
              <br />
              LEAD CAPTURE
            </strong>
            <br />
            Account creation with saved searches, online forms.
          </Grid>
        </Grid>

        <Grid container columnSpacing={16} style={{ textAlign: "center" }}>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image
                src="/details_icon.svg"
                width="100px"
                height="100px"
                alt="Elm Street IDX Websites - Listing Property Details"
              />
            </div>
            <strong>
              LISTING/
              <br />
              PROPERTY DETAILS
            </strong>
            <br />
            Display property <br />
            &amp; community essentials, tourism, social media sharing &amp; more.
          </Grid>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image
                src="/seo_icon.svg"
                width="100px"
                height="100px"
                alt="Elm Street IDX Websites - Seo-Friendly Features"
              />
            </div>
            <strong>
              SEO-FRIENDLY
              <br />
              FEATURES
            </strong>
            <br />
            Indexable listings &amp; optimized titles, meta &amp; keyword tags.
          </Grid>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image src="/blog_icon.svg" width="100px" height="100px" alt="Elm Street IDX Websites - Robust Blog" />
            </div>
            <strong>ROBUST BLOG</strong>
            <br />
            Automated listing updates and relevant lifestyle content without the effort.
          </Grid>
          <Grid item md={3} sm={12}></Grid>
        </Grid>
      </Container>

      <div
        style={{
          backgroundImage: "url('mapbg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
        alt="Elm Street IDX Websites - MLS Coverage Map"
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  height: "350px",
                }}
              >
                <div>
                  <Typography variant="h4" component="h5">
                    we've got
                    <br />
                    <span style={{ color: mainTheme.palette.secondary.main }}>you covered</span>
                  </Typography>
                  <p>
                    Powered by IDX Broker, we service most
                    <br />
                    of the United States &amp; Canada.
                  </p>
                  <Button variant="contained" color="secondary" href="/markets">
                    See Full Coverage List
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <div
        style={{
          backgroundImage: "url('orangebg.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg" style={{ paddingTop: "80px", paddingBottom: "85px" }}>
          <div style={{  }}>
            <a id="form" />
            <Typography variant="h4" component="h4" style={{ color: "#1d1746",textAlign: "center" }}>
              schedule a demo today
            </Typography>
            <div style={{ paddingBottom: "40px",textAlign: "center" }}>
              <strong style={{ color: "#1d1746" }}>
                See for yourself what fully loaded website can do for you &amp; your business!
              </strong>
            </div>
            <div style={{ padding: "40px", backgroundColor: "#ffffff" }}>
              <Container
                maxWidth="lg"
                style={{
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  marginTop: "65px",
                  marginBottom: "65px",
                }}
              >
                <Grid container>
                  <Grid item md={2} sm={12} xs={12} />
                  <Grid item md={8} sm={12} xs={12}>
                    <DemoForm
                      formName="es2_idx_websites"
                      buttonText="Schedule Demo"
                      successUrl="thankyou"
                      listId="147985"
                      fieldList={["first_name", "last_name", "email", "phone", "roll", "idx_options"]}
                    />
                  </Grid>
                </Grid>
              </Container>
            </div>
          </div>
        </Container>
      </div>

      <MainFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
